stateProviders.push({
    name: "schoolside.settings.award.awardLetter",
    url: "/awardLetter",
    templateUrl: "fast/submodules/schoolside/settings/awardSettings/awardLetter/partials/awardLetter.html?v=" + versionNo,
    controller: "AwardLetterController",
	resolve: {
        alt: function(AwardLetterTemplatesModelService, authServiceFactory)
        {
            return AwardLetterTemplatesModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        account: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.get(authServiceFactory.getAuth().schoolID);
        },
        thresh: function(SchoolModelService, authServiceFactory)
        {
            SchoolModelService.get(authServiceFactory.getAuth().schoolID);
        }
	}
});